import React, { useEffect, useRef, useState } from "react";

import regbanner from "../../assets/icons/regBanner.jpeg";
import useQuery from "../../customHooks/useQuery";
import { initialDocObj } from "../DocumentVerification/DocVerificationForm/DocVerificationForm";
import { saveDocumentObj } from "../Registration/PANInfo/PANInfo";
import { AUploadDocument } from "../Services/dashboard/brokerageServices";
import {
  ACheckLocation,
  ACheckPhotoLiveness,
  ASaveDocumentDetails,
  AGetUploadedDocument,
  ADownloadDocument,
} from "../Services/dashboard/docVerificationAPIServices";
import { ASelfieLock, ASaveIPVerificationDetails } from "../Services/dashboard/ipvApiServices";
import { AGetStageCompletionStatus } from "../Services/registration/continueApiService";
import { AGetClientDetailsByPan, AGetSelfieClientData } from "../Services/registration/panDobApiService";
import GlobalStore from "../store/globalStore";
import Button from "../UI/Button/Button";
import { DocDetailFormat } from "../UI/DocumentBrowse/DocumentBrowse";
import { errorMessage } from "../utils/errorMessage";
import { geoLocationConfig } from "../utils/constants";
import useGeoLocation from "../../customHooks/useGeoLocation";
import InfoModal from "../UI/InfoModal/InfoModal";
import DeviceContext from "../Services/identifyDevice";

import "./Selfie.scss";
import { setStageData, utmDurationInfoObj } from "../Services/globalService";
import gtmService from "../Services/gtmService";
import mixpanelService from "../Services/mixpanelService";
import mixpanelEvents, { getScreenName } from "../../config/mixpanelEvents";
import ErrMsg from "../UI/ErrMsg/ErrMsg";
import { NewLineKind } from "typescript";
import NewSelfie from "./NewSelfie";
import { usePageTitle } from '../../hooks/usePageTitle';
export interface iGeoLocation {
  loaded: boolean;
  coordinates: { lat: string; lng: string };
  error: boolean;
}
export interface IQueryObject {
  PanNo?: string;
  AccountCategory?: string;
  userid?: number;
}
const Selfie = () => {
  usePageTitle('Selfie Upload');
  const queryParams = useQuery();
  const [esignGenerated, setEsignGenerated] = React.useState<boolean>(false);
  const id = queryParams.get("id") ? queryParams.get("id") : "";
  // const accountCategory =
  //   queryParams.get("accountCategory") !== null &&
  //   queryParams.get("accountCategory") !== undefined &&
  //   queryParams.get("accountCategory") !== ""
  //     ? queryParams.get("accountCategory")
  //     : "";
  const [hasPhoto, setHasPhoto] = useState(false);
  const [photoObj, setPhotoObj] = React.useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [showRetake, setShowRetake] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [errCode, setErrCode] = React.useState<number | string>("");
  const [eSignCompleted, setESignCompleted] = useState(false);
  const [streams, setStreams] = useState<any>();
  const [lat, setLat] = useState<any>("");
  const [long, setLong] = useState<any>("");
  const [startTime, setStartTime] = React.useState<Date>(new Date());

  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const geoLoc: iGeoLocation = useGeoLocation();
  const [isGeoError, setIsGeoError] = React.useState<boolean>(false);
  const [isGeoErrorTimeFlag, setIsGeoErrorTimeFlag] =
    React.useState<boolean>(false);
  let userId = 0;
  const [showBrowserPermissionModal, setsShowBrowserPermissionModal] =
    useState<boolean>(false);
  const [showSelfieLockModal, setShowSelfieLockModal] = useState<boolean>(false);
  const [selfieLockMessage, setSelfieLockMessage] = useState<string>("");
  const [lockChecking, setLockChecking] = useState<boolean>(false);
  const [isPhotoAutoPopulated, setIsPhotoAutoPopulated] = useState<boolean>(false);
  const [isSdkSelfie, setIsSdkSelfie] = useState<boolean>(true);
  const [browserPermission, setBrowserPermission] = useState<boolean>(true);
  const [locationPermission, setLocationPermission] = useState<boolean>(true);
  const [cameraPermission, setCameraPermission] = useState<boolean>(true);
  const [liveLocationCheck, setLiveLocationCheck] = useState<any>({
    checkPhotoLiveness: true,
    checkLocation: true,
  });
  const [photoErrorMsg, setPhotoErrorMsg] = React.useState("");
  const [geoLocation, setGeoLocation] = useState<any>({});

  let watchPositionId: number;
  const [createdby, setCreatedBy] = React.useState<any>(0);
  let base64String: string;
  let saveDetails: saveDocumentObj[] = [];

  useEffect(() => {
    if (id) {
      const fixedId = decodeURIComponent(id.replace(/\s/g, "+"));
      // let panObj: any = atob(id),
      //   panObjFound: boolean = false;
      // if (
      //   typeof panObj == "string" &&
      //   panObjFound == false &&
      //   !panObj?.includes("PanNo")
      // ) {
      AGetSelfieClientData(searchByPan, fixedId);
      // } else {
      //   panObj = JSON.parse(atob(id)) as IQueryObject;
      //   console.log("pan", panObj?.PanNo);
      //   let accountCategoryNo = 1;
      //   if (
      //     panObj !== undefined &&
      //     panObj?.userid !== null &&
      //     panObj?.userid !== undefined
      //   ) {
      //     userId = panObj?.userid;
      //     setCreatedBy(panObj?.userid);
      //   }
      //   if (
      //     panObj?.AccountCategory !== "" &&
      //     panObj?.AccountCategory !== undefined &&
      //     panObj?.AccountCategory !== null
      //   ) {
      //     accountCategoryNo = parseInt(panObj?.AccountCategory);
      //   }
      //   if (panObj?.PanNo)
      //     AGetClientDetailsByPan(
      //       searchByPan,
      //       panObj?.PanNo,
      //       accountCategoryNo,
      //       panObj?.userid
      //     );
      // }
    }
  }, [id]);

  useEffect(() => {
    console.log("Use effect called");
    if (!isSdkSelfie) {
      setTimeout(() => {
        watchPositionId = navigator.geolocation.watchPosition(
          successPosition,
          errorPosition
        );
        setIsGeoErrorTimeFlag(true);
      }, geoLocationConfig.errorTimer);

      canvasRef.current!.hidden = true;
    }

    //     intiateCamera();
  }, []);
  const shouldDisable = () => {
    let disabled: boolean = false;
    if (
      GlobalStore?.stageStatus?.first_esign_initiated !== null &&
      GlobalStore?.stageStatus?.first_esign_initiated !== undefined &&
      GlobalStore?.stageStatus?.first_esign_initiated
    ) {
      disabled = true;
      setEsignGenerated(true);
    }
    return disabled;
  };
  React.useEffect(() => {
    if (!isSdkSelfie) {
      watchPositionId = navigator.geolocation.watchPosition(
        successPosition,
        errorPosition
      );
      if (locationPermission === true && cameraPermission === true) {
        console.log("inside setter ");
        setBrowserPermission(true);
        setsShowBrowserPermissionModal(false);
        setIsGeoError(false);
        setIsLoading(false);
      } else {
        console.log("inside setter else");
        setBrowserPermission(false);
        setsShowBrowserPermissionModal(true);
        setIsGeoError(true);
        setIsLoading(true);
      }
    }
    // getLocation();
  }, [geoLoc, locationPermission, cameraPermission, isSdkSelfie]);

  React.useEffect(() => {
    //     initiateCamera();
    if (lat && long && !isSdkSelfie) {
      const locationObj = {
        lat: lat,
        lng: long,
      };
      ACheckLocation((res: any) => checkLocationRes(res), locationObj);
    }
  }, [lat, long, isSdkSelfie]);

  const checkLocationRes = (res: any) => {
    if (!res || res.error) {
      // setErrCode("116 - Error in fetching Pan details from our system.");
      // setErrCode(errorMessage.panDetailsFailed);
      setErrCode(res.error);
      setIsLoading(false);
      setLiveLocationCheck((prev: any) => {
        return {
          ...prev,
          checkLocation: true,
        };
      });
      gtmService({ action: "CheckLocation", label: "ERROR || ERR999" });
    } else {
      if (res.data && res.data.LocationInIndia) {
        setLiveLocationCheck((prev: any) => {
          return {
            ...prev,
            checkLocation: false,
          };
        });
        setErrCode("");
      } else if (!res.data.LocationInIndia) {
        setLiveLocationCheck((prev: any) => {
          return {
            ...prev,
            checkLocation: true,
          };
        });
        setErrCode(res.data.Message);
      }
      setIsLoading(false);
    }
  };

  const getLocation = () => {
    if (geoLoc.loaded && geoLoc.error == false) {
      console.log("I'm here");
      setLat(`${geoLoc.coordinates.lat}`);
      setLong(`${geoLoc.coordinates.lng}`);
      GlobalStore.location = {
        lat: geoLoc.coordinates.lat,
        long: geoLoc.coordinates.lng,
      };
    } else {
      if (navigator && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(setLocation, errorLocation, {
          enableHighAccuracy: geoLocationConfig.enableHighAccuracy,
          maximumAge: geoLocationConfig.maximumAge,
          timeout: geoLocationConfig.timeout,
        });
      } else {
        alert("Geo location is not supported by this browser");
      }
      watchPositionId = navigator.geolocation.watchPosition(
        successPosition,
        errorPosition
      );
    }
  };

  function successPosition(data: any) {
    setIsLoading(false);
    setLocationPermission(true);

    // setBrowserPermission(true);
    // setsShowBrowserPermissionModal(false);
    GlobalStore.location = {
      lat: data.coordinates.lat,
      long: data.coordinates.lng,
    };
    setLat(data.coords.latitude);
    setLong(data.coords.longitude);
    navigator.geolocation.clearWatch(watchPositionId);
  }

  function errorPosition(data: any) {
    setIsLoading(true);
    setLocationPermission(false);

    // setBrowserPermission(false);
    // setsShowBrowserPermissionModal(true);
    // if (!browserPermission) {
    //   getLocation();
    // }
  }

  function errorLocation(err: any) {
    console.log(`ERROR(${err.code}): ${err.message}`);
    geoLoc.error = true;
    setIsLoading(true);
    setIsGeoError(true);
    // getLocation();
  }

  const setLocation = (position: { coords: any }) => {
    console.log(position.coords);
    setLat(position.coords.latitude);
    setLong(position.coords.longitude);
    GlobalStore.location = {
      lat: position.coords.latitude,
      long: position.coords.longitude,
    };
    geoLoc.coordinates.lat = position.coords.latitude;
    geoLoc.coordinates.lng = position.coords.longitude;
    geoLoc.error = false;
    setIsGeoError(false);
    setIsGeoErrorTimeFlag(false);
    setIsLoading(false);
    console.log("In saveLocation", geoLoc);
  };

  function saveIPVerification(data: any, uploadObj: saveDocumentObj, res: any) {
    let latitude = lat;
    let longitude = long;
    const ipvObj = {
      leadid: GlobalStore.leadId,
      clientprimarydetailid: GlobalStore.clientPrimaryDetailId,
      applicationid: GlobalStore.applicationID,
      placeofDeclaration: "mumbai",
      empName: "diy user",
      designation: "online rm",
      branch: "mumbai",
      empCode: "0",
      organization: "Nuvama Wealth & investment Ltd.",
      organizationCode: "2",
      // geo_location: `${latitude}, ${longitude}`,
      latitude: latitude,
      longitude: longitude,
      ipaddress: "192.168.200.80",
      source: "Selfie",
      createdBy: createdby !== null ? createdby : userId,
      geoLocationCountry: geoLocation?.Country,
      geoLocationCity: geoLocation?.City,
    };
    //ASaveIPVerificationDetails(iPVerificationSaved, ipvObj);

    ASaveIPVerificationDetails(
      (response: any) => iPVerificationSaved(response, uploadObj, res),
      ipvObj
    );
  }

  const iPVerificationSaved = (
    res: any,
    uploadObj: saveDocumentObj,
    prevres: any
  ) => {
    if (!res || res.error) {
      // setErrCode("Error in saving geo-location details");
      setErrCode(res.error);
      gtmService({
        action: "SaveIpverificationDetails",
        label: "ERROR || ERR146",
      });
      setIsLoading(false);
    } else {
      gtmService({
        action: "SaveIpverificationDetails",
        label: "ERROR || ERR146-S",
      });
      setIsLoading(false);
      //uploadObj.fileName = prevres.data.Guid;
      saveDetails = [];
      alert(
        "Selfie captured successfully, please close this browser window and continue with your Account Opening process"
      );
      //ASaveDocumentDetails(() => documentDetailsSaved(res), saveObj);
    }
  };

  const searchByPan = (res: any) => {
    if (!res || res.error) {
      // setErrCode("118 - Error in fetching Client details from our system.");
      setErrCode(res.error);
      gtmService({
        action: "GetClientDataByPanOrLead",
        label: "ERROR || ERR148",
      });
      setIsLoading(false);
    } else {
      setIsLoading(true);
      if (res.data) {
        if (res.data != null) {
          GlobalStore.personaldetails.pan = res.data.PAN;
          GlobalStore.token = res.data.Token;
          GlobalStore.applicationID = res.data.ApplicatoinId;
          GlobalStore.leadId = res.data.LeadId;
          GlobalStore.clientPrimaryDetailId = res.data.ClientPrimaryDetailId;
          if (!isSdkSelfie) {
            getLocation();
            AGetStageCompletionStatus(
              (res: any) => getClientStageDetails(res),
              GlobalStore.applicationID
            );
          } else {
            AGetStageCompletionStatus((res: any) => {
              if (!res || res.error) {
                // setErrCode('1061 - Error in fetching stage completion details.');
                // setErrCode(errorMessage.getClientStageDetails);
                gtmService({
                  action: "GetStageCompletionStatus",
                  label: "ERROR || ERR147",
                });
                setErrCode(res.error);
              } else {
                if (res.data) {
                  const responseObj = JSON.parse(res.data);
                  setStageData(responseObj);
                  if (
                    responseObj?.first_esign_initiated !== null &&
                    responseObj?.first_esign_initiated !== undefined &&
                    responseObj?.first_esign_initiated
                  ) {
                    setEsignGenerated(true);
                  }
                } else {
                  gtmService({
                    action: "GetStageCompletionStatus",
                    label: "ERROR || ERR147-S",
                  });
                }
              }
            }, GlobalStore.applicationID);
            setIsLoading(false);
          }
        }
      } else {
        setErrCode("1182 - Error in fetching Client details from our system.");
        setIsLoading(false);
        gtmService({
          action: "GetClientDataByPanOrLead",
          label: "ERROR || ERR148-S",
        });
      }
    }
  };

  function getClientStageDetails(res: any) {
    setIsLoading(false);
    if (!res || res.error) {
      // setErrCode('1061 - Error in fetching stage completion details.');
      // setErrCode(errorMessage.getClientStageDetails);
      gtmService({
        action: "GetStageCompletionStatus",
        label: "ERROR || ERR147",
      });
      setErrCode(res.error);
    } else {
      if (res.data) {
        const responseObj = JSON.parse(res.data);
        setStageData(responseObj);
        if (
          responseObj?.first_esign_initiated !== null &&
          responseObj?.first_esign_initiated !== undefined &&
          responseObj?.first_esign_initiated
        ) {
          setEsignGenerated(true);
        }
        if (responseObj.isesigncompleted) {
          console.log("Esign Completed");
          setESignCompleted(true);
        }
      } else {
        gtmService({
          action: "GetStageCompletionStatus",
          label: "ERROR || ERR147-S",
        });
      }
    }
  }

  const HandleNewSDKSelfieRes = (data: any) => {
    setGeoLocation(data)
    if (data && data.errMsg) {
      if (data.errMsg === "User close the liveliness") {
        ASelfieLock(() => {}, GlobalStore.applicationID, "RELEASE");
      }
      setBrowserPermission(true);
    } else if (data.is_valid == "1" && data.Latitude && data.Longitude) {
      // setIsLoading(true);
      const new_File = new File(
        [Blob as unknown as BlobPart],
        "personalPhoto.jpeg",
        {
          type: "image/jpeg",
          lastModified: Date.now(),
        }
      );

      setHasPhoto(true);

      let base64 = data?.cropped_image;
      base64String = base64;
      setPhotoObj((prev: any) => {
        return {
          ...prev,
          base64: base64String,
          imgUrl: `data:image/jpeg;base64, ${base64}`,
        };
      });
      //   data.Country="ID";
      if (data?.Country && data?.Country.toLowerCase() == "india") {
        setErrCode("");
        setLiveLocationCheck({
          ...liveLocationCheck,
          checkLocation: false,
          checkPhotoLiveness: false,
        });
        if (
          data?.Latitude !== null &&
          data?.Longitude !== null &&
          data?.Latitude !== undefined &&
          data?.Longitude !== undefined
        ) {
          setLat(data.Latitude);
          setLong(data.Longitude);
        } else {
          if (
            GlobalStore?.location !== null &&
            GlobalStore?.location !== undefined &&
            GlobalStore?.location?.lat !== null &&
            GlobalStore?.location?.lat !== undefined &&
            GlobalStore?.location?.lat !== "" &&
            GlobalStore?.location?.long !== null &&
            GlobalStore?.location?.long !== undefined &&
            GlobalStore?.location?.long !== ""
          ) {
            setLat(GlobalStore?.location?.lat);
            setLong(GlobalStore?.location?.long);
          }
          // else {
          //   setErrCode(
          //     errCode
          //       ? errCode
          //       : " " +
          //           "Oops, you are not in permitted range of account opening as per regulatory guidelines."
          //   );
          // }
        }
      } else {
        setLiveLocationCheck({
          ...liveLocationCheck,
          checkLocation: true,
        });

        setErrCode(
          errCode
            ? errCode
            : " " +
            "Oops, you are not in permitted range of account opening as per regulatory guidelines."
        );
      }
    }
  };

  const isLockFree = (res: any) =>
    !res || res.error || res.status !== true || res.data?.lockStatus !== "LOCKED";

  const isLockAcquiredByUs = (res: any) =>
    res && !res.error && res.status === true &&
    res.data?.success === true && res.data?.lockStatus === "LOCKED";

  const handleCameraButtonClick = (proceed: () => void) => {
    if (lockChecking) return;
    setLockChecking(true);
    // Step 0: Check if a photograph has already been uploaded
    AGetUploadedDocument((uploadRes: any) => {
      if (!uploadRes || uploadRes.error) {
        setLockChecking(false);
        return;
      }
      const uplDoc = JSON.parse(uploadRes.data);
      const existingPhoto = uplDoc.find(
        (x: any) => x.DocumentCategory === "Photograph"
      );
      if (existingPhoto) {
        setLockChecking(false);
        setIsPhotoAutoPopulated(true);
        photoObj.id = "photo";
        photoObj.disable = false;
        photoObj.uploadPer = 100;
        photoObj.fileName = existingPhoto.FileName;
        photoObj.showFile = false;
        photoObj.hideProgress = false;
        photoObj.mimeType = existingPhoto.MimeType;
        photoObj.documentCategoryId = existingPhoto.DocumentCategoryId;
        photoObj.documentId = existingPhoto.DocumentId;
        photoObj.documentcategory = existingPhoto.DocumentCategory;
        setPhotoObj(photoObj);
        ADownloadDocument((dlRes: any) => {
          if (dlRes && !dlRes.error && dlRes.data) {
            const mimeType = existingPhoto.MimeType || "image/jpeg";
            setPhotoObj((prev: any) => ({
              ...prev,
              base64: dlRes.data.base64document,
              imgUrl: `data:${mimeType};base64,${dlRes.data.base64document}`,
            }));
            setHasPhoto(true);
          }
        }, existingPhoto.FileName, existingPhoto.UploadedDocPath);
        setSelfieLockMessage("A selfie has already been captured or uploaded for this application. Recapturing is not allowed.");
        setShowSelfieLockModal(true);
        return;
      }
      // Step 1: STATUS — check if lock is already held
      ASelfieLock(
        (statusRes: any) => {
          if (!isLockFree(statusRes)) {
            // Lock is held by another — show popup, skip ACQUIRE
            setLockChecking(false);
            setSelfieLockMessage("Selfie capture is currently being used by another user. Please refresh the page or re-enter this stage and try again after 60 seconds.");
            setShowSelfieLockModal(true);
            return;
          }
          // Step 2: Lock is free — ACQUIRE then open SDK
          ASelfieLock(
            (acquireRes: any) => {
              setLockChecking(false);
              if (isLockAcquiredByUs(acquireRes)) {
                proceed();
              } else {
                const msg = acquireRes && acquireRes.error
                  ? "Unable to verify selfie lock. Please try again."
                  : "Selfie capture is currently being used by another user. Please refresh the page or re-enter this stage and try again after 60 seconds.";
                setSelfieLockMessage(msg);
                setShowSelfieLockModal(true);
              }
            },
            GlobalStore.applicationID,
            "ACQUIRE"
          );
        },
        GlobalStore.applicationID,
        "STATUS"
      );
    }, GlobalStore.applicationID);
  };



  const intiateCamera = async () => {
    canvasRef.current!.hidden = true;
    const constraints = {
      audio: false,
      video: {
        facingMode: "user",
      },
    };

    try {
      const userMedia = await navigator.mediaDevices.getUserMedia(constraints);
      const video = videoRef.current;
      if (video) {
        video.srcObject = userMedia;
        await video.play();
        setStreams(userMedia);
      }
    } catch (err) {
      alert(err);
    }
    setShowRetake(true);
  };

  const takePhoto = async () => {
    canvasRef.current!.hidden = false;

    let video = videoRef.current;
    let canvas = canvasRef.current;

    if (canvas && video) {
      // console.log('If canvas');
      const width = video.videoWidth;
      const height = video.videoHeight;
      canvas.width = width;
      canvas.height = height;
      let ctx = canvas.getContext("2d");

      videoRef.current!.hidden = true;
      ctx?.drawImage(video, 0, 0, width, height);

      canvas.toBlob((blob) => storePhoto(blob));

      closePhoto();
    }
    setHasPhoto(true);
  };

  const closePhoto = () => {
    streams?.getTracks().forEach((track: { stop(): any }) => {
      track.stop();
    });
  };

  const storePhoto = (blob: Blob | null) => {
    const new_File = new File([blob as BlobPart], "personalPhoto.jpeg", {
      type: "image/jpeg",
      lastModified: Date.now(),
    });
    if (new_File.size > 50000000) {
      alert("video size exceeds maximum limit. Please upload it again");
      return false;
    }
    if (new_File.size < 1000) {
      alert("video size should be greater than 1KB. Please upload it again");
      return false;
    }

    const fileReader = new FileReader();
    fileReader.readAsDataURL(new_File);
    fileReader.onload = function (event) {
      const base64 = (event.target && event.target.result)?.toString();
      base64String = base64!.split(",")[1];
      photoObj.base64 = base64String;
      // console.log(base64String);
      setIsLoading(true);
      ACheckPhotoLiveness(
        (res: any) => getExtractPhotoLiveness(res),
        base64String,
        GlobalStore.leadId
      );
    };
  };
  const getExtractPhotoLiveness = (res: any) => {
    if (!res || res.error) {
      // setErrCode("116 - Error in fetching Pan details from our system.");
      // setErrCode(errorMessage.panDetailsFailed);
      setErrCode(res.error);
      setPhotoErrorMsg("");
      setIsLoading(false);
      setLiveLocationCheck((prev: any) => {
        return {
          ...prev,
          checkPhotoLiveness: true,
        };
      });
      gtmService({ action: "checkPhotoLiveness", label: "ERROR || ERR998" });
    } else {
      if (res.data && res.data.IsLive) {
        setPhotoErrorMsg(res.data.Message);
        setLiveLocationCheck((prev: any) => {
          return {
            ...prev,
            checkPhotoLiveness: false,
          };
        });
        setErrCode("");
      } else if (!res.data.IsLive) {
        setLiveLocationCheck((prev: any) => {
          return {
            ...prev,
            checkPhotoLiveness: true,
          };
        });
        setPhotoErrorMsg(res.data.Message);
        // if (errCode !== res.data.Message) {
        //   setErrCode(res.data.Message);
        // }
      }
      setIsLoading(false);
    }
  };

  const uploadSelfie = () => {
    console.log("lat", lat);
    console.log("long", long);
    if (lat !== "" && lat !== undefined && long !== "" && long !== undefined) {
      setIsLoading(true);
      if (photoObj.base64 !== "" || photoObj.base64 !== undefined) {
        photoObj.id = "photo";
        photoObj.disable = false;
        photoObj.uploadPer = 100;
        photoObj.fileName = `${GlobalStore.applicationID}_Photo`;
        photoObj.showFile = false;
        photoObj.hideProgress = false;
        photoObj.mimeType = "image/jpeg";
        photoObj.documentId = 2;
        photoObj.documentCategoryId = "1";
        setPhotoObj(photoObj);
        const savePhotoObj: saveDocumentObj = {
          documentCategoryId: photoObj.documentCategoryId?.toString(),
          documentId: photoObj.documentId?.toString(),
          fileName:
            photoObj.fileName +
            (photoObj.mimeType === "application/pdf" ? ".pdf" : ".jpg"),
          isfilecropped: false,
          mimeType: photoObj.mimeType || ".",
          panno: GlobalStore.personaldetails.pan,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        saveDetails.push(savePhotoObj);

        const saveObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: saveDetails,
          leadId: GlobalStore.leadId,
        };

        const selfie = true;
        const modifiedBy = window.sessionStorage.getItem('empCode')
        const photoUploadObj = {
          applicationid: GlobalStore.applicationID,
          base64document: photoObj.base64,
          panNo: GlobalStore?.personaldetails.pan,
          filename:
            photoObj.fileName +
            (photoObj.mimeType === "application/pdf" ? ".pdf" : ".jpg"),
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };

        AUploadDocument(
          (res: any) => getUploadResponse(res, savePhotoObj),
          photoUploadObj,
          () => { },
          saveObj
        );
        saveIPVerification({ coords: {} }, savePhotoObj, undefined);
      } else {
        setErrCode("Error in uploading the file...");
      }
    } else {
      setsShowBrowserPermissionModal(true);
    }
  };

  const getUploadResponse = (res: any, uploadObj: saveDocumentObj) => {
    saveDetails = [];
    if (!res || res.error) {
      // setErrCode("1361- Error in uploading the file.");
      setErrCode(res.error);
      setIsLoading(false);
    } else {
      if (res.data !== null && res.data) {
        //    saveIPVerification({ coords: {} }, uploadObj, res);
        // uploadObj.fileName = res.data.Guid;
        // saveDetails.push(uploadObj);
        // const objUTM_Info = utmDurationInfoObj(startTime, "documentsdur");
        // const saveObj = {
        //   applicationId: GlobalStore.applicationID,
        //   clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
        //   documentInfo: saveDetails,
        //   leadId: GlobalStore.leadId,
        //   objUTM_Info: objUTM_Info,
        // };
        // ASaveDocumentDetails(() => documentDetailsSaved(res), saveObj);
      } else {
        setErrCode(res.error);
        gtmService({
          action: "UploadDocumentToS3",
          label: "ERROR || ERR144-S",
        });
      }
    }
  };

  const documentDetailsSaved = (res: any) => {
    if (!res || res.error) {
      setErrCode(res.error);
      gtmService({
        action: "SaveUploadedDocumentDetails",
        label: "ERROR || ERR145",
      });
      setIsLoading(false);
      saveDetails = [];
    } else if (res) {
      saveDetails = [];
      alert(
        "Selfie captured successfully, please close this browser window and continue with your Account Opening process"
      );
    } else {
      gtmService({
        action: "SaveUploadedDocumentDetails",
        label: "ERROR || ERR145-S",
      });
    }
  };
  async function turnOnCamera() {
    getLocation();

    const constraints = {
      audio: false,
      video: {
        facingMode: "user",
      },
    };

    function handleSuccess(turnOfCamera: MediaStream) {
      console.log("HANDLE success", turnOfCamera);
      // setBrowserPermission(true);
      // setsShowBrowserPermissionModal(false);
      setCameraPermission(true);
      setIsLoading(false);
    }

    function handleError(error: any) {
      console.log("HANDLE ERROR", error);
      setIsLoading(true);
      // setBrowserPermission(false);
      // setsShowBrowserPermissionModal(true);
      setCameraPermission(false);
      console.log("handle error line end");
      // if (!browserPermission) {
      //   turnOnCamera();
      // }
    }

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        console.log(stream, "then");
        handleSuccess(stream);
      })
      .catch((stream) => {
        console.log(stream, "catch");
        handleError(stream);
      });
  }

  console.log(
    "hasPhoto",
    !hasPhoto,
    isGeoError,
    liveLocationCheck.checkPhotoLiveness,
    liveLocationCheck.checkLocation
  );
  return (
    <>
      <div className="mgt40">
        <div className="fieldLblRight">
          <div className="explain">
            {showBrowserPermissionModal && (
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <InfoModal width={DeviceContext().isMobile ? "328px" : "354px"}>
                  <div style={{ margin: "16px" }} className="explainInfo w-100">
                    <p>
                      To open your account online, we would mandatorily need
                      access to your geo locations and camera. In your browser
                      notification, click on 'Allow' to proceed ahead
                    </p>
                  </div>
                  <div style={{ marginTop: "16px" }}>
                    <Button
                      btnName="OK"
                      onClick={() => {
                        turnOnCamera();
                        // setsShowBrowserPermissionModal(false);
                      }}
                    />
                    {/* OK
                    </Button> */}
                  </div>
                </InfoModal>
              </div>
            )}
            {showSelfieLockModal && (
              <div className="modal-overlay">
                <div className="modal-content" role="dialog" aria-modal="true">
                  <h2 className="modal-title">Selfie In Use</h2>
                  <p className="modal-text">{selfieLockMessage}</p>
                  <div className="modal-actions">
                    <button
                      type="button"
                      className="modal-button"
                      onClick={() => setShowSelfieLockModal(false)}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <fieldset disabled={isLoading}>
        <legend className="sr-only">Photo upload</legend>
        <div className={`container  ${eSignCompleted ? "readOnly" : ""}`}>
          {/* <div className="banner">
                <img className="bannerImg" src={regbanner} alt="" aria-hidden="true" />
            </div> */}
          <h2 className="heading">Personal Photo</h2>
          <br />
          <p className="photoSubHeading">
            Click a selfie making sure your face is clearly visible.
          </p>
          <div className="imageBox">
            {isSdkSelfie ? (
              <>
                <NewSelfie
                  callback={(data: any) => {
                    HandleNewSDKSelfieRes(data);
                  }}
                  onFailedToOpenSdk={setIsSdkSelfie}
                  disabledClick={lockChecking || isPhotoAutoPopulated}
                  onCameraButtonClick={handleCameraButtonClick}
                />
                {photoObj.base64 && (
                  <section className="photo-cont">
                    <img src={photoObj.imgUrl} alt="photograph" />
                  </section>
                )}
              </>
            ) : (
              <>
                <video
                  className="videoBox"
                  id="videoPersonal"
                  ref={videoRef}
                  autoPlay
                  playsInline
                />
                {!hasPhoto && <div className="photoOutline"></div>}
                {!hasPhoto && <div className="captureFrame"></div>}
                {!showBrowserPermissionModal && (
                  <div>
                    {" "}
                    {!showRetake ? (
                      <div className="cameraBtn">
                        <button
                          type="button"
                          onClick={() => {
                            try {
                              const screen_name = getScreenName(window.location.pathname);
                              if (screen_name) {
                                mixpanelService({
                                  event: mixpanelEvents.CTA_CLICKED,
                                  screen_name,
                                  text: "Ready?",
                                  cta_type: "sticky",
                                  cta_class: "primary",
                                  cta_service: "AOJ",
                                });
                              }
                            } catch (e) {
                              console.error("mixpanel cta_clicked failed", e);
                            }
                            intiateCamera();
                          }}
                          style={{ color: "white", background: "transparent", border: "none", cursor: "pointer" }}
                          aria-label="Ready to take photo"
                        >
                          Ready?
                        </button>
                      </div>
                    ) : hasPhoto ? (
                      <div className="cameraBtn">
                        <button
                          type="button"
                          className="edel-icon-retake"
                          aria-label="Retake photo"
                          onClick={() => {
                            try {
                              const screen_name = getScreenName(window.location.pathname);
                              if (screen_name) {
                                mixpanelService({
                                  event: mixpanelEvents.CTA_CLICKED,
                                  screen_name,
                                  text: "Retake photo",
                                  cta_type: "sticky",
                                  cta_class: "secondary",
                                  cta_service: "AOJ",
                                });
                              }
                            } catch (e) {
                              console.error("mixpanel cta_clicked failed", e);
                            }
                            videoRef.current!.hidden = false;
                            setHasPhoto(false);
                            intiateCamera();
                          }}
                        ></button>
                      </div>
                    ) : (
                      <div className="cameraBtn">
                        <button
                          type="button"
                          className="edel-icon-camera"
                          aria-label="Take photo"
                          onClick={() => {
                            try {
                              const screen_name = getScreenName(window.location.pathname);
                              if (screen_name) {
                                mixpanelService({
                                  event: mixpanelEvents.CTA_CLICKED,
                                  screen_name,
                                  text: "Take photo",
                                  cta_type: "sticky",
                                  cta_class: "primary",
                                  cta_service: "AOJ",
                                });
                              }
                            } catch (e) {
                              console.error("mixpanel cta_clicked failed", e);
                            }
                            takePhoto();
                          }}
                        ></button>
                      </div>
                    )}{" "}
                  </div>
                )}
                <canvas ref={canvasRef} id="capture" className="canvasImg" />
              </>
            )}
          </div>

          {isGeoError && !isGeoErrorTimeFlag ? (
            <>
              <div className="geoErrorMsg">
                <p>
                  {" "}
                  There is a delay in loading the contents, please wait for a
                  moment !!
                </p>
              </div>
            </>
          ) : null}

          {isGeoError && isGeoErrorTimeFlag ? (
            <>
              <div className="geoErrorMsg">
                <p>
                  {" "}
                  There was a delay in loading the contents, refresh the page!!{" "}
                </p>
              </div>
            </>
          ) : null}
          {/* Error Msg Start*/}
          {errCode && (
            <div className="errMsgBlck errWidth mrt40">
              <ErrMsg>
                {typeof errCode === "number" ? (
                  <>
                    <span>We are facing some technical issue.</span>
                    <span>
                      Please try after sometime (error code:{errCode})
                    </span>
                  </>
                ) : (
                  <span>{errCode}</span>
                )}
              </ErrMsg>
            </div>
          )}
          {/* Error Msg End*/}
          {isGeoError && isGeoErrorTimeFlag ? (
            <>
              <div className="geoErrorMsg">
                <p>
                  {" "}
                  There was a delay in loading the contents, refresh the page!!{" "}
                </p>
              </div>
            </>
          ) : null}
          {/* Error Msg Start*/}

          {/* Photo Error Msg Start*/}
          {photoErrorMsg != "" && (
            <div className="errMsgBlck">
              <ErrMsg>
                <span>{photoErrorMsg}</span>
              </ErrMsg>
            </div>
          )}
          {esignGenerated && (
            <div className="errMsgBlck">
              <ErrMsg>
                <span>Photo Cannot be edited as E-Sign Link is Generated.</span>
              </ErrMsg>
            </div>
          )}
          {/* Photo Error Msg End*/}

          {/* {errCode && (
            <div className="errMsgBlck errWidth mrt40">
              <ErrMsg>
                {typeof errCode === "number" ? (
                  <>
                    <label>We are facing some technical issue.</label>
                    <label>
                      Please try after sometime (error code:{errCode})
                    </label>
                  </>
                ) : (
                  <label>{errCode}</label>
                )}
              </ErrMsg>
            </div>
          )} */}
          {/* Error Msg End*/}
          <div className="row">
            <Button
              onClick={uploadSelfie}
              btnName="Submit"
              isLoading={isLoading}
              disabled={
                !hasPhoto ||
                isGeoError ||
                liveLocationCheck.checkPhotoLiveness ||
                liveLocationCheck.checkLocation ||
                esignGenerated
              }
              type="submit"
            />
          </div>
        </div>
      </fieldset>
    </>
  );
};

export default Selfie;
